import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RadioButtonComponent
  from './../Components/RadioButtonComponent.jsx';
import { changeScenariosBy } from './../actions';

import {
  getScenariosBy,
  getScenariosByRadioButtons
} from './../reducers';
import { scenarios as constants } from './../helpers';

class RadioButtonContainer extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    onChangeFunctionCall: PropTypes.func.isRequired,
    optionSelected: PropTypes.string.isRequired,
  };

  render() {

    const renderOptions = [];
    let counter = 0;

    this.props.options.forEach((option) => {
      switch (option) {
        case constants.scenariosByImageName:
          renderOptions.push(
            <RadioButtonComponent
              {...this.props} value={option}
              label="By Image Name"
              key={counter}
            />
          );
          break;
        case constants.scenariosByJobType:
          renderOptions.push(
            <RadioButtonComponent
              {...this.props} value={option}
              label="By Job Type"
              key={counter}
            />
          );
          break;
        case constants.scenariosByPlatform:
          renderOptions.push(
            <RadioButtonComponent
              {...this.props} value={option}
              label="By Platform"
              key={counter}
            />
          );
          break;
      }
      counter++;
    });


    return (
      <div>
        <fieldset>
          <legend>
            Details
          </legend>
        </fieldset>
        <form>
          {renderOptions}
        </form>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    optionSelected: getScenariosBy(state),
    options: getScenariosByRadioButtons(state)
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onChangeFunctionCall: scenariosBy => {
    dispatch(changeScenariosBy(scenariosBy));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RadioButtonContainer);


// WEBPACK FOOTER //
// src/Containers/RadioButtonContainer.jsx